export const FETCH_COUNTRIES = 'folderActions/FETCH_COUNTRIES';
export const FETCH_COUNTRIES_SUCCESS = 'folderActions/FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAILED = 'folderActions/FETCH_COUNTRIES_FAILURE';

export const UPDATE_COUNTRY = 'folderActions/UPDATE_COUNTRY';
export const UPDATE_COUNTRY_SUCCESS = 'folderActions/UPDATE_COUNTRY_SUCCESS';
export const UPDATE_COUNTRY_FAILED = 'folderActions/UPDATE_COUNTRY_FAILURE';

export function fetchCountries() {
  return {
    type: FETCH_COUNTRIES,
  };
}

export function fetchCountriesSuccess(countries) {
  return {
    type: FETCH_COUNTRIES_SUCCESS,
    countries,
  };
}

export function fetchCountriesFailed(err) {
  return {
    type: FETCH_COUNTRIES_FAILED,
    err,
  };
}

export function updateCountry(id, country) {
  return {
    type: UPDATE_COUNTRY,
    id,
    country,
  };
}

export function updateCountrySuccess(country) {
  return {
    type: UPDATE_COUNTRY_SUCCESS,
    country,
  };
}

export function updateCountryFailed(err) {
  return {
    type: UPDATE_COUNTRY_FAILED,
    err,
  };
}
